import { useSidepanelContext } from '@contexts/sidepanel'
import React from 'react'


function useSidepanel() {
    const sidepanel = useSidepanelContext()

    function open<T extends object>(Component: React.VoidFunctionComponent<T>, props: T) {
        sidepanel.open(<Component {...props} />)
    }

    const close = () => {
        sidepanel.close()
    }

    return { open, close }
}

export default useSidepanel